import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { head } from '@/router/Head';
import { logoutSearchSchema } from '@/router/utils';

export const Route = createFileRoute('/(auth)/logout')({
  validateSearch: logoutSearchSchema,
  staticData: {
    title: 'Signing out ...',
    domain: 'auth',
  },
  component: lazyRouteComponent(() => import('./logout.component'), 'LogoutComponent'),
  head,
});
